

import React from 'react';
import { useAppContext } from '../../hooks/useAppContext';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  // Allow overriding the top accent stripe color (defaults to primary gradient)
  accentClass?: string;
  interactive?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
    ({ className, children, accentClass = 'bg-gradient-primary', interactive = false, ...props }, ref) => {
        const { designMode } = useAppContext();
        const isModern = designMode === 'modern';
        return (
            <div
                ref={ref}
                className={`relative ${isModern ? 'glass-card rounded-2xl' : 'bg-white dark:bg-slate-700 rounded-xl'} shadow-sm hover:shadow-md hover:-translate-y-[2px] transition-all duration-300 ${interactive ? 'card-motion' : ''} ${className}`}
                {...props}
            >
                <div className={`absolute top-0 left-0 right-0 h-2 ${accentClass} rounded-t-xl z-10`}></div>
                {children}
            </div>
        );
    }
);

export const CardHeader: React.FC<CardProps> = ({ className, children, ...props }) => (
    <div className={`p-6 ${className}`} {...props}>
        {children}
    </div>
);

export const CardTitle: React.FC<React.HTMLAttributes<HTMLHeadingElement>> = ({ className, children, ...props }) => (
    <h3 className={`text-lg font-semibold text-slate-900 dark:text-slate-100 ${className}`} {...props}>
        {children}
    </h3>
);


export const CardContent: React.FC<CardProps> = ({ className, children, ...props }) => (
    <div className={`p-6 ${className}`} {...props}>
        {children}
    </div>
);

export const CardFooter: React.FC<CardProps> = ({ className, children, ...props }) => (
    <div className={`p-6 border-t border-slate-200 dark:border-slate-600 ${className}`} {...props}>
        {children}
    </div>
);
